module.exports = __webpack_public_path__ + "img/case-logo-45.86db79e1.png";